import { useEffect, useState } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import apiInstance from "../../utils/axios";
import request from "../../utils/request";
import UserData from "../plugins/UserData";
import '../../../css/product.css';
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import useAxios from '../../utils/useAxios'
import imageCompression from 'browser-image-compression';



const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});

function Product() {
    const [isLoading, setIsLoading] = useState(false);
    const [productNames, setProductNames] = useState([]);
    const [wineCategories, setWineCategories] = useState([])
    const [wineQualities, setWineQualities] = useState([])
    const [subCategories, setSubCategories] = useState([])
    const [blendings, setBlendings] = useState([])
    const [origins, setOrigins] = useState([])
    const [wineTypes, setWineTypes] = useState([])
    const [wineTypesInfo, setWineTypesInfo] = useState([])
    const [imagePreview, setImagePreview] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);


    const { t } = useTranslation(); 
    const {hashedId} = useParams();
    const navigate = useNavigate();
    const api = useAxios();

    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);

    const [formData, setFormData] = useState({
        product_name: '',
        category: '',
        sub_category: '',
        blending_type: '',
        wine_type: [],
        wine_qual: '',
        vintage: '',
        origin: '',
        product_picture: '',
    });

    const userId = UserData().user_id;



    const fetchProductNames = async () => {
        if (!api) return; // Check if api is defined
        setIsLoading(true);
        try {
            const res = await api.get(`productnames/${userId}/`);
            const fetchedOptions = res.data.map((name) => ({
                value: name.id,
                label: name.name,
            }));
            setProductNames(fetchedOptions);
        } catch (error) {
            console.error("Error fetching product data:", error);
            Toast.fire({
                icon: "error",
                title: "Please Login!",
            });
            navigate('/login')
        } finally {
            setIsLoading(false);
        }
    };

    const fetchProductSelection = async () => {
        if (!api) return;
        setIsLoading(true);
        try {
            
            const res = await api.get(`product-selection/`);

            let fetchedWineCategories = res.data?.wine_categories.map((item) => ({
                value: item.id,
                label: item.translations[`${lang}`]?.name || item.translations['de']?.name
            }                
            ));
            fetchedWineCategories = [
                { value: "", label: "" },
                ...fetchedWineCategories, 
              ];
            setWineCategories(fetchedWineCategories);
        
            let fetchedWineQualities = res.data?.wine_qualities.map((item) => ({
                value: item.id,
                label: item.translations[`${lang}`]?.name || item.translations['de']?.name
            }                
            ));

            fetchedWineQualities = [
                { value: "", label: "" },
                ...fetchedWineQualities, 
              ];
            setWineQualities(fetchedWineQualities);

            let fetchedSubCategories = res.data?.sub_categories.map((item) => ({
                value: item.id,
                label: item.translations[`${lang}`]?.name || item.translations['de']?.name
            }                
            ));
            fetchedSubCategories = [
                { value: "", label: "" },
                ...fetchedSubCategories, 
              ];
            setSubCategories(fetchedSubCategories);

            let fetchedBlendings = res.data?.blendings.map((item) => ({
                value: item.id,
                label: item.translations[`${lang}`]?.name || item.translations['de']?.name
            }                
            ));
            fetchedBlendings = [
                { value: "", label: "" },
                ...fetchedBlendings,
              ];
            setBlendings(fetchedBlendings);

            let fetchedOrigins = res.data?.origins.map((item) => ({
                value: item.id,
                label: item.translations[`${lang}`]?.name || item.translations['de']?.name
            }                
            ));

            fetchedOrigins = [
                { value: "", label: "" },
                ...fetchedOrigins,
              ];
            setOrigins(fetchedOrigins);

            const fetchedWineTypes = res.data?.wine_types.map((item) => ({
                value: item.id,
                label: item.name
            }                
            ));
            
            setWineTypesInfo(res.data?.wine_types)
            setWineTypes(fetchedWineTypes);

            
        } catch (error) {
            
        } finally {
            setIsLoading(false);
        }
    }



    useEffect(() => {
        if (api) {
            fetchProductNames();
            fetchProductSelection();
        }
    }, [api, lang]);

    useEffect(() => {
        if (hashedId && productNames.length > 0) {
            apiInstance.get(`decode-id/${hashedId}/`).then((res) => {
                const selectedProduct = productNames.find(productName => productName.value === res.data.id);
                setFormData(prev => ({
                    ...prev,
                    product_name: selectedProduct || null,
                }));
            }).catch(error => {
                console.error("Error fetching or decoding ID:", error);
            });
        }
    }, [hashedId, productNames, lang]);


    const handleChange = (eventOrSelectedOptions, { name, type }) => {
        setFormData((prev) => {
            let updatedValue;

            if (type === 'select-multiple') {
                updatedValue = eventOrSelectedOptions
                    ? eventOrSelectedOptions.map(option => option.value)
                    : []
                }

            
            else if (type === "select-one") {
                switch (name) {
                    case "product_name":
                        updatedValue = productNames.find((productName) => productName.value ===  (eventOrSelectedOptions ? eventOrSelectedOptions.value : null));
                        break;
                    case "category":
                        updatedValue = wineCategories.find((wineCategory) => wineCategory.value ===  (eventOrSelectedOptions ? eventOrSelectedOptions.value : null));
                        break
                    case "wine_qual":
                        updatedValue = wineQualities.find((wineQual) => wineQual.value ===  (eventOrSelectedOptions ? eventOrSelectedOptions.value : null));
                        break;
                    case "origin":
                        updatedValue = origins.find((origin) => origin.value ===  (eventOrSelectedOptions ? eventOrSelectedOptions.value : null));
                        break;
                    case "blending_type":
                        updatedValue = blendings.find((blending) => blending.value ===  (eventOrSelectedOptions ? eventOrSelectedOptions.value : null));
                        break;
                    case "sub_category":
                        updatedValue = subCategories.find((subCategory) => subCategory.value ===  (eventOrSelectedOptions ? eventOrSelectedOptions.value : null));
                        break;
                  } 
            } else if (type === "file") {
                updatedValue = eventOrSelectedOptions ? eventOrSelectedOptions.target.files[0] : null;
            } else {
                updatedValue =  eventOrSelectedOptions ? eventOrSelectedOptions.target.value : null;
            }
            return {
                ...prev,
                [name]: updatedValue,
            };
        });
    };


    const validateForm = async (formData) => {
        
        if (formData.product_picture) {
            const fileSize = formData.product_picture.size / 1024 / 1024; // Convert size to MB
            if (fileSize > 10) {
                Toast.fire({
                    icon: "error",
                    title: t("product.form.messages.productPictureSizeWarning"),
                });
                return false;
            }
        }

        if (!formData.product_name ||
            !formData.category ||
            !formData.wine_type ||
            // !formData.wine_qual ||
            // !formData.vintage ||
            !formData.origin
        ) {
            Toast.fire({
                icon: "error",
                title: t("product.form.messages.requiredFields"),
            })
            return false;
        }

        const selectedCategoryValue = formData.category?.value;
        const selectedCategoryLabel = formData.category?.label;

        // Determine the label for "Red wine" based on language
        const redWineLabel = lang === "de" ? "Rotwein" : "Red wine";

        // If the selected label is "Rosé", find the value for "Red wine"/"Rotwein"
        let adjustedCategoryValue = selectedCategoryValue;
        if (selectedCategoryLabel && selectedCategoryLabel.toLowerCase() === "rosé") {
            const redWineCategory = wineCategories.find(cat => cat.label === redWineLabel);
            if (redWineCategory) {
                adjustedCategoryValue = redWineCategory.value;
            }
        }

        const selectedWineTypeObjects = wineTypesInfo.filter(item => formData.wine_type.includes(item.id));

        const wineCategoryCheck = selectedWineTypeObjects.every(item => item.wine_category == adjustedCategoryValue);

        // --- Blend check ---
        const isBlendSelected = formData.blending_type && formData.blending_type.label && formData.blending_type.label.toLowerCase().includes(formData.blending_type.label.toLowerCase());
        if (isBlendSelected && formData.wine_type.length < 2) {
            await Swal.fire({
                icon: "warning",
                title: t("product.form.messages.blendingWineTypeWarning"),
                confirmButtonColor: "#3085d6",
            });
            return false;
        }

        if (!isBlendSelected && formData.wine_type.length > 1) {
            await Swal.fire({
                icon: "warning",
                title: t("product.form.messages.blendingTypeWarning"),
                confirmButtonColor: "#3085d6",
            });
            return false;
        }

        if (!wineCategoryCheck) {
            await Swal.fire({
                icon: "warning",
                title: t("product.form.messages.categoryCheckWarning"),
                confirmButtonColor: "#3085d6",
            });
            // alert("Please only select wine types from the selected category.")
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        if (!api) return; // Check if api is defined
        e.preventDefault();

        const isValid = await validateForm(formData);
        if (!isValid) {
            return
        } 
        const formDataToSend = new FormData();
        Object.entries(formData).forEach(([key, value]) => { // Renamed 'object' to 'value' for clarity
            if (value instanceof File) {
                // Handle File objects (like product_picture) directly
                formDataToSend.append(key, value);
            } else if (value instanceof Object) { // Check for Objects (non-File objects)
                if (Array.isArray(value)) {
                    // Handle multi-select fields (arrays of values)
                    value.forEach((val) => formDataToSend.append(key, val));
                } else if (value !== null && value !== undefined && value.hasOwnProperty('value')) { // Check for value property in objects
                    formDataToSend.append(key, value.value); // Extract .value for objects like category, origin etc.
                }
            } else {
                // Handle primitive values (strings, numbers, booleans) directly
                formDataToSend.append(key, value);
            }
        });
        
        try {
            setIsLoading(true);
            const response = await api.post(`products/`,  formDataToSend, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percent);
                },
                timeout: 35000
            })
    
            if (response.status === 201) {
                setIsLoading(false);
                const data = await response.data;
                const productId = data.id;

                Toast.fire({
                    icon: "success",
                    title: t("product.form.messages.formSuccess"),
                })

                const resp = await apiInstance.get(`/hash-id/${productId}/`)
                const hashedId = resp.data.hashed_id
                navigate(`/product-nutrients/${hashedId}`)

            } else {
                setIsLoading(false);
                console.error("Error submitting form");
            }
        } catch (error) {
            setIsLoading(false);
            if (error.code === 'ECONNABORTED') {
                alert("Upload timed out. Please check your internet connection and try again.");
            } else if (error.response?.status === 403) {
                Toast.fire({
                icon: "error",
                title: error.response?.data?.message || t("product.form.messages.formError"),
            })
            } else {
                console.error("Network error:", error);
                Toast.fire({
                    icon: "error",
                    title: t("product.form.messages.formError"),
                })
            }
        }
    };

    const handleImageChange = async (event) => {
        // const file = event.target.files[0];

        const file = event.target.files[0];
        if (!file) return;

        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
        };

        try {
            const compressedBlob = await imageCompression(file, options);
            // Convert Blob to File and preserve the original file name and type
            const compressedFile = new File(
                [compressedBlob],
                file.name,
                { type: compressedBlob.type }
            );

            if (compressedFile) {
                const reader = new FileReader();
                reader.onload = () => {
                    setImagePreview(reader.result); // Set the preview URL
                };
                reader.readAsDataURL(compressedFile); // Read the file as a data URL
            }

            setImagePreview(URL.createObjectURL(compressedFile));
            setFormData((prev) => ({
                ...prev,
                product_picture: compressedFile,
            }));
        } catch (error) {
            console.error("Image compression error:", error);
            // Optionally show a toast or alert here
        }

    };

    const customStyles = {
        control: (styles, { isFocused }) => ({
          ...styles,
          border: 'none', // Remove the border
          boxShadow: 'none', // Remove the blue outline on focus
          ':hover': {
              borderBottomColor: 'gray'
          }
        }),
          option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
          ...styles,
          fontSize: '16px',
          cursor: isDisabled ? 'not-allowed' : 'default',
          backgroundColor: isSelected ? '#eee' : isFocused ? '#f5f5f5' : 'white',
          color: isDisabled ? '#ccc' : 'black',
          height: '2.5rem',
          display: 'flex',
          alignItems: 'center',
        }),
        menu: (styles) => ({
          ...styles,
          width: 'calc(80% - 22px)',
          boxSizing: 'border-box',
        }),
          multiValue: (styles) => ({
            ...styles,
            backgroundColor: '#f0f0f0', // Example background color
            borderRadius: 4,
            margin: 2,
            padding: 3,
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: 'gray',
            ':hover': {
                backgroundColor: 'lightgray',
                color: 'black',
                cursor: 'pointer',
            },
        }),
        indicatorSeparator: (styles) => ({ // Target the vertical line
            ...styles,
            display: 'none', // Hide the vertical line
          }),
        dropdownIndicator: (styles) => ({ // Target the dropdown arrow
        ...styles,
        padding: 3, 
        color: 'black', 
        svg: {
            width: '0.85em', // Adjust width to change arrow size
            height: '1em', // Adjust height to change arrow size
        },
        }),
      };
      

  return (
    <>
    {productNames.length > 0 && (
        <div className="container">
            <p className="form-heading-1">{t("product.form.heading")}</p>
            <p className="desc-text">{t("product.form.description")}</p>
            <form className="form-width-1" onSubmit={handleSubmit}>
                <div className="form-input-container-1">
                    <label htmlFor="productName" className="form-label-1 no-margin">{t("product.form.labels.productName")}</label>
                    <Select
                        // isMulti
                        options={productNames}
                        value={formData.product_name}
                        onChange={(e) => handleChange(e, { name: 'product_name', type: "select-one"})}
                        className="form-input-2"
                        placeholder=""
                        isSearchable  // Enable search
                        styles={customStyles}
                    />
                </div>

                <div className="form-input-container-1">
                    <label htmlFor="wine_type" className="form-label-1 no-margin">{t("product.form.labels.wineType")}</label>
                    <Select
                        isMulti
                        options={wineTypes}
                        value={formData.wine_type.map(value => wineTypes.find(option => option.value === value))}
                        onChange={(selectedOptions) => handleChange(selectedOptions, { name: 'wine_type' , type: 'select-multiple'})}
                        className="form-input-2"
                        placeholder=""
                        isSearchable  // Enable search
                        styles={customStyles}
                    />
                </div>

                <div className="form-input-container-1">
                    <label htmlFor="category" className="form-label-1 no-margin">{t("product.form.labels.category")}</label>
                    <Select
                        // isMulti
                        options={wineCategories}
                        onChange={(e) => handleChange(e, { name: 'category' , type: "select-one"})}
                        className="form-input-2"
                        placeholder=""
                        isSearchable  // Enable search
                        styles={customStyles}
                    />
                </div>

                <div className="form-input-container-1">
                    <label htmlFor="wine_qual" className="form-label-1 no-margin">{t("product.form.labels.wineQuality")}</label>
                    <Select
                        // isMulti
                        options={wineQualities}
                        onChange={(e) => handleChange(e, { name: 'wine_qual', type: "select-one" })}
                        className="form-input-2"
                        placeholder=""
                        isSearchable  // Enable search
                        styles={customStyles}
                    />
                </div>

                <div className="form-input-container-1">
                    <label htmlFor="origin" className="form-label-1 no-margin">{t("product.form.labels.origin")}</label>
                    <Select
                        // isMulti
                        options={origins}
                        onChange={(e) => handleChange(e, { name: 'origin', type: "select-one" })}
                        className="form-input-2"
                        placeholder=""
                        isSearchable  // Enable search
                        styles={customStyles}
                    />
                </div>

                <div className="form-input-container-1">
                    <label htmlFor="vintage" className="form-label-1 no-margin">{t("product.form.labels.vintage")}</label>
                    <input
                        id="vintage"
                        name="vintage"
                        className="form-input-2"
                        value={formData.vintage}
                        onChange={(e) => handleChange(e, { name: 'vintage' })}
                        placeholder=""
                        type="number"
                    />
                </div>

                <div className="form-input-container-1">
                    <label htmlFor="blending_type" className="form-label-1 no-margin">{t("product.form.labels.blendingType")}</label>
                    <Select
                        // isMulti
                        options={blendings}
                        onChange={(e) => handleChange(e, { name: 'blending_type' , type: "select-one"})}
                        className="form-input-2"
                        placeholder=""
                        isSearchable  // Enable search
                        styles={customStyles}
                    />
                </div>

                <div className="form-input-container-1">
                    <label htmlFor="sub_category" className="form-label-1 no-margin">{t("product.form.labels.subCategory")}</label>
                    <Select
                        // isMulti
                        options={subCategories}
                        onChange={(e) => handleChange(e, { name: 'sub_category', type: "select-one" })}
                        className="form-input-2"
                        placeholder=""
                        isSearchable
                        styles={customStyles}
                    />
                </div>
                <div className="form-input-container-1 form-adapt-button-left-1"> 
                    <label htmlFor="productPicture" className="file-label-2">
                        <input
                            id="productPicture"
                            name="productPicture"
                            type="file"
                            className="file-input"
                            onChange={handleImageChange}
                            
                        />
                        <span className="file-label-2-text">{formData.product_picture ? formData.product_picture.name : t("product.form.labels.productPicture")}</span>
                    </label>

                    {imagePreview && (
                        <img
                            src={imagePreview}
                            alt="Product Preview"
                            className="image-preview"
                        />
                    )}

                </div>
                <div className="form-input-container-3">
                {isLoading 
                ? <button disabled className="form-button-submit-2" type="submit">
                    <i className="fas fa-spinner fa-spin"></i>
                    <span className="mr-2">Processing</span>
                    </button>
                : <button className="form-button-submit-2" type="submit"><span className="mr-2">Submit</span>
                    </button>
                }
                </div>
            </form>
        </div>      
    )}
    {productNames.length === 0 && (
        <div className="activate-account-container">
            <div className="form-inner-container-2">
                <h3>{t("product.form.messages.createProductName")}</h3>
                <button className="form-button-submit-1">
                    <a className="link-button" href="/product-names">{t("product.form.buttons.createProductName")}</a>
                </button>
            </div>
        </div>
    )}
    </>
  )
}

export default Product